import { Component, AfterViewInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'search',
  styles: [require('./search.component.scss')],
  template: require('./search.component.html')
})
export class SearchComponent implements AfterViewInit, OnDestroy {
  @Input()
  public searchText: string;

  @Output()
  public searchTextChange = new EventEmitter();

  @Input()
  public searchTextPlaceHolder = 'Search ...';

  @ViewChild('searchInput')
  public searchInput: ElementRef;

  public search: Observable<void>;
  public subscribtion: Subscription;

  public ngAfterViewInit(): void {
    this.subscribeSearchInput();
  }

  public ngOnDestroy(): void {
    if (this.subscribtion) {
      this.subscribtion.unsubscribe();
    }
  }

  private subscribeSearchInput() {
    const input = this.searchInput.nativeElement;
    this.search = Observable.fromEvent(input, 'keyup')
        .debounceTime(300)
        .map(() => {
          this.searchTextChange.emit(input.value);
        }
    );

    if (this.search) {
      this.subscribtion = this.search.subscribe();
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/search/search.component.ts